<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M3.6 3.6L16.4 3.6L16.4 9.2L3.6 9.2L3.6 3.6ZM3.6 10.8L3.6 16.4L16.4 16.4L16.4 10.8L3.6 10.8ZM17 2C17.5523 2 18 2.44772 18 3L18 17C18 17.5523 17.5523 18 17 18L3 18C2.44771 18 2 17.5523 2 17L2 3C2 2.44771 2.44771 2 3 2L17 2Z"
          fill="#2E1E51" fill-opacity="0.54"/>
</svg>
